import React from 'react';
import styles from './WorkoutSavingOverlay.module.css';

interface WorkoutSavingOverlayProps {
  isVisible: boolean;
  message?: string;
  hasError?: boolean;
  errorMessage?: string;
  onErrorAcknowledge?: () => void;
}

export const WorkoutSavingOverlay: React.FC<WorkoutSavingOverlayProps> = ({
  isVisible,
  message = 'Saving your workout...',
  hasError = false,
  errorMessage,
  onErrorAcknowledge
}) => {
  if (!isVisible) return null;

  return (
    <div className={styles.overlay}>
      <div className={`${styles.modal} ${hasError ? styles.error : ''}`}>
        <div className={`${styles.spinner} ${hasError ? styles.errorSpinner : ''}`}></div>
        <h3 className={`${styles.title} ${hasError ? styles.errorTitle : ''}`}>
          {hasError ? (errorMessage || 'Failed to save workout') : message}
        </h3>
        <p className={`${styles.subtitle} ${hasError ? styles.errorSubtitle : ''}`}>
          {hasError 
            ? 'Please complete all exercises with at least one set each and try again'
            : 'Please wait while we save your progress'
          }
        </p>
        {hasError && onErrorAcknowledge && (
          <button className={styles.errorButton} onClick={onErrorAcknowledge}>
            OK
          </button>
        )}
      </div>
    </div>
  );
};
